import '../src/polyfills';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';

import '../client/src/index.css';
import './globals.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
); 